import { render } from "./lastDetailsPublish.vue?vue&type=template&id=60334705"
import script from "./lastDetailsPublish.vue?vue&type=script&lang=js"
export * from "./lastDetailsPublish.vue?vue&type=script&lang=js"

import "./lastDetailsPublish.vue?vue&type=style&index=0&id=60334705&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/createProject/lastDetailsPublish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60334705"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60334705', __exports__)) {
    api.reload('60334705', __exports__)
  }
  
  module.hot.accept("./lastDetailsPublish.vue?vue&type=template&id=60334705", () => {
    api.rerender('60334705', render)
  })

}


export default __exports__